var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',{staticClass:"copyright"},[_vm._v("© 2019-"+_vm._s(_vm.year)+" 车库Lab")])])}
var staticRenderFns = []

export { render, staticRenderFns }